/**
 * Ashore API
 * All Endpoints to control your ashore account
 *
 * The version of the OpenAPI document: V1
 * Contact: info@ashoreapp.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The KeySizes model module.
 * @module model/KeySizes
 * @version V1
 */
class KeySizes {
    /**
     * Constructs a new <code>KeySizes</code>.
     * @alias module:model/KeySizes
     */
    constructor() { 
        
        KeySizes.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>KeySizes</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/KeySizes} obj Optional instance to populate.
     * @return {module:model/KeySizes} The populated <code>KeySizes</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new KeySizes();

            if (data.hasOwnProperty('minSize')) {
                obj['minSize'] = ApiClient.convertToType(data['minSize'], 'Number');
            }
            if (data.hasOwnProperty('maxSize')) {
                obj['maxSize'] = ApiClient.convertToType(data['maxSize'], 'Number');
            }
            if (data.hasOwnProperty('skipSize')) {
                obj['skipSize'] = ApiClient.convertToType(data['skipSize'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>KeySizes</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>KeySizes</code>.
     */
    static validateJSON(data) {

        return true;
    }


}



/**
 * @member {Number} minSize
 */
KeySizes.prototype['minSize'] = undefined;

/**
 * @member {Number} maxSize
 */
KeySizes.prototype['maxSize'] = undefined;

/**
 * @member {Number} skipSize
 */
KeySizes.prototype['skipSize'] = undefined;






export default KeySizes;

